import {gql} from "@apollo/client";

export default gql`
  query getJobs(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $status: JobStatuses
    $employerId: String
    $start: DateRangeInput
    $end: DateRangeInput
    $timeframe: Timeframes
    $visibility: JobVisibility
    $like: [JobFilterInput!]
    $order: [JobOrderInput!]
    $filled: Boolean
    $actionRequired: Boolean
    $isActive: Boolean
    $isQueued: Boolean
    $isFixedTerm: Boolean
    $timezone: String
  ) {
    jobs(
      first: $first
      last: $last
      after: $after
      before: $before
      status: $status
      employerId: $employerId
      start: $start
      end: $end
      timeframe: $timeframe
      visibility: $visibility
      like: $like
      order: $order
      filled: $filled
      actionRequired: $actionRequired
      isActive: $isActive
      isQueued: $isQueued
      isFixedTerm: $isFixedTerm
      timezone: $timezone
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          employerId
          start
          end
          startUtc
          endUtc
          timezone
          peopleNeeded
          city
          region
          positionsFilled
          checkedInCount
          checkedOutCount
          skills
          jobSkill {
            id
            skillId
            skill {
              skillName
              isActive
              frenchSkillName
              createdAt
              id
            }
          }
          isFixedTerm
          jobRecurring{
            frequencyEndAt
          }
          workType{
            id
            label
            frenchName
          }
          positions {
            id
            isConfirmed
            isReconfirmed
            startShift
            endShift
          }
          employer {
            id
            companyName
          }
        }
      }
    }
  }
`;
